"use client";

import { deleteLesson } from "@/app/actions";
import { countStudents } from "@/app/utils/helpers";
import type { Lesson } from "@prisma/client";
import Link from "next/link";

type LessonListProps = {
	lessonsOnDisplayMonth: Lesson[];
};

export default function LessonList(props: LessonListProps) {
	const handleDelete = (id: string) => {
		deleteLesson(id);
	};
	return (
		<div>
			<div className="flex-col space-y-3 px-3 py-6 lg:px-12">
				{props.lessonsOnDisplayMonth.map((lesson) => (
					<div
						key={lesson.id}
						className="mx-auto max-w-xl rounded-md bg-white p-3 shadow-sm"
					>
						<div className="flex flex-wrap items-center justify-between">
							<div className="grid flex-1 grid-cols-[auto_1fr] items-baseline gap-x-2">
								<div className="font-medium">日付：</div>
								<div>
									{lesson.startTime
										.toLocaleDateString("ja-JP", {
											year: "numeric",
											month: "2-digit",
											day: "2-digit",
											weekday: "short",
											timeZone: "Asia/Tokyo",
										})
										.replace(/\((.)\)/, "（$1）")}
								</div>

								<div className="font-medium">時刻：</div>
								<div>
									{lesson.startTime
										.toLocaleTimeString("ja-JP", {
											hour: "2-digit",
											minute: "2-digit",
											timeZone: "Asia/Tokyo",
										})
										.slice(0, 5)}
								</div>
								<div className="font-medium">時間：</div>
								<div>{lesson.minutes}分</div>
								<div className="font-medium">生徒：</div>
								<div>{countStudents(lesson.students)}</div>
								<div className="font-medium">賃金：</div>
								<div>{lesson.wage.toLocaleString()}円</div>
							</div>
							<div className="flex-col">
								<div className="my-1 rounded-md border bg-green-500 p-3 font-medium text-white transition-colors duration-200 hover:bg-green-800">
									<Link href={`/edit/${lesson.id}`}>
										<button type="button">編集</button>
									</Link>
								</div>
								<div className="my-1 rounded-md border bg-red-300 p-3 font-medium text-white transition-colors duration-200 hover:bg-red-700">
									<button
										type="button"
										onClick={() => handleDelete(lesson.id)}
									>
										削除
									</button>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
